import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    siteWarnList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    siteType: {
      type: String,
      defult: 1
    },
    height: {
      type: String,
      default: '435px'
    },
    top: {
      type: String,
      default: '0px'
    },
    defaultValue: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    },
    radioStatu: {
      type: Boolean,
      default: false
    },
    radioTop: {
      type: String,
      default: '22px'
    }
  },
  methods: {}
};